import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';

export default function initImageSlider() {

  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideClass: 'cmeleon-block-content',
    breakpoints: {
      1024: {
        centeredSlides: false,
        slidesPerView: 6,
      },
    }
  });

  new Swiper('.image-swiper', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs
    },
    slideClass: 'cmeleon-block-content',
    loopFillGroupWithBlank: false,
  });
}
